import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

const Whychooseusa = () => {
  return (
    <div className="whychooseusa p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              <span>Why Choose</span> TekRevol As Your Magento Web Development
              Company?
            </h2>
          </Col>
        </Row>
        <Row className="h-100 choose_padd">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <p>
              Choosing TekRevol as your Magento development agency promises a
              host of benefits stemming from our specialized expertise and
              commitment to excellence.
            </p>
            <p>
              Our dedicated Magento website developers possess an unparalleled
              understanding of Magento's complexities, ensuring the delivery of
              top-tier solutions aligned precisely with your business
              objectives.
            </p>
            <p>
              What sets us apart is our capability of crafting tailored
              solutions, customizing every facet to fit your unique needs, and
              ensuring an impactful digital presence.
            </p>
            <p>
              At TekRevol, our commitment extends beyond development; we offer
              continuous support and maintenance to ensure your platform's
              sustained optimal performance. Partner with Tekrevol to witness
              your Magento-powered website flourish into a powerhouse of sales
              and customer engagement.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Book A Free Consultation Today
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
            <StaticImage
              src="../../images/services-usa/magento/why_choose.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={775}
              height={650}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Whychooseusa;
